import React from "react";
import { Link } from "react-router-dom";
import { BlogPost } from "../../types";
import type { ViewMode } from "../common/ViewToggle";

interface BlogCardProps {
  post: BlogPost;
  variant?: ViewMode;
}

const getPostUrl = (post: BlogPost) => {
  if (post.link && post.link.startsWith("/") && post.link.length > 1) {
    return post.link;
  }
  return `/blog/${
    post.slug ??
    post.title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)+/g, "")
  }`;
};

const BlogCard: React.FC<BlogCardProps> = ({ post, variant = "grid" }) => {
  const isList = variant === "list";

  const imageBlock = (
    <div
      className="blog-card__image"
      style={
        isList
          ? {
              flex: "0 0 280px",
              minHeight: "200px",
              overflow: "hidden",
            }
          : undefined
      }
    >
      <img
        src={post.image}
        alt={post.imageAlt}
        style={isList ? { width: "100%", height: "100%", objectFit: "cover" } : undefined}
      />
      <div className="blog-card__overlay">
        <Link to={getPostUrl(post)} className="blog-card__link">
          <i className="fas fa-arrow-right"></i>
        </Link>
      </div>
    </div>
  );

  const contentBlock = (
    <div className="blog-card__content" style={isList ? { flex: "1", padding: "1.25rem 1.5rem" } : undefined}>
      <div className="blog-card__meta">
        <span className="blog-card__date">
          <i className="fas fa-calendar"></i>
          {post.date}
        </span>
      </div>
      <h3 className="blog-card__title">
        <Link to={getPostUrl(post)}>{post.title}</Link>
      </h3>
      <p className="blog-card__excerpt">{post.excerpt}</p>
      <div className="blog-card__tags">
        {post.tags.map((tag, index) => (
          <span key={index} className="tag">
            {tag}
          </span>
        ))}
      </div>
    </div>
  );

  if (isList) {
    return (
      <div className="col-12 mb-4">
        <div
          className="blog-card blog-card--list"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "stretch",
            overflow: "hidden",
            borderRadius: "12px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          }}
        >
          {imageBlock}
          {contentBlock}
        </div>
      </div>
    );
  }

  return (
    <div className="col-xl-4 col-lg-4 col-md-6 mb-4">
      <div className="blog-card">
        {imageBlock}
        {contentBlock}
      </div>
    </div>
  );
};

export default BlogCard;
